module.exports = __webpack_public_path__ + "img/battery_low.c0549325.svg";